'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["option"];
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { ATTRIBUTION_MODELS } from '../../utils/constants';
import { PQL_KEYS } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const langKey = key => `components.revenueAttributionCard.${key}`;
export default function Toolbar({
  attributionModel,
  hasRevenueAttributionAccess,
  link,
  onAttributionModelChange
}) {
  const {
    openUpgradeModal
  } = useUpgradeModal(PQL_KEYS.TOGGLE_MODEL);
  const selectOptions = Object.keys(ATTRIBUTION_MODELS).filter(model => model !== 'LINEAR_PRO').map(model => {
    return {
      text: I18n.text(langKey(`modelSelect.${model}`)),
      value: ATTRIBUTION_MODELS[model]
    };
  });
  const isPQL = val => val !== ATTRIBUTION_MODELS.LINEAR && !hasRevenueAttributionAccess;
  const OptionComponent = _ref => {
    let {
        option: {
          value,
          text
        }
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
      children: /*#__PURE__*/_jsxs(Button, {
        onClick: isPQL(value) ? openUpgradeModal : null,
        use: "unstyled",
        children: [text, isPQL(value) && /*#__PURE__*/_jsx(LockBadge, {})]
      })
    }));
  };
  const onSelectOption = ({
    target: {
      value
    }
  }) => {
    if (!isPQL(value)) {
      onAttributionModelChange(value);
    }
  };
  return /*#__PURE__*/_jsx(TFlex, {
    direction: "column",
    children: /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      alignSelf: "end",
      children: [link, /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('modelSelectLabel')
      }), /*#__PURE__*/_jsx(Select, {
        "data-test-id": "revenue-attribution-card--model-select",
        menuWidth: "auto",
        optionComponent: OptionComponent,
        buttonUse: "transparent",
        onChange: onSelectOption,
        options: selectOptions,
        value: attributionModel
      })]
    })
  });
}
Toolbar.propTypes = {
  attributionModel: PropTypes.string.isRequired,
  link: PropTypes.node,
  onAttributionModelChange: PropTypes.func.isRequired,
  hasRevenueAttributionAccess: PropTypes.bool
};